'use strict';

export default {
  devStoreConfig: false,
  api: {
    default: 'https://morning-wave-18791.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client5.js